const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const ChatSentenceAdd = () => import(/* webpackChunkName: "chat" */ './sentence/view/add.vue');
const ChatSentenceEdit = () => import(/* webpackChunkName: "chat" */ './sentence/view/edit.vue');
const ChatSentenceList = () => import(/* webpackChunkName: "chat" */ './sentence/view/index.vue');
const ChatSentenceTranslate = () => import(/* webpackChunkName: "chat" */ './sentence/view/translate.vue');
const ChatSetting = () => import(/* webpackChunkName: "chat" */ './setting/view/edit.vue');

export const ROUTE_NAME_CHAT = {
    SETTING: 'ChatSetting',
    SENTENCE: {
        INDEX: 'ChatSentenceList',
        ADD: 'ChatSentenceAdd',
        EDIT: 'ChatSentenceEdit',
        TRANSLATE: 'ChatSentenceTranslate'
    }
};

export default [
    {
        path: '/app/:appId/chat',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'sentence',
                name: ROUTE_NAME_CHAT.SENTENCE.INDEX,
                component: ChatSentenceList,
                meta: { requiresAuth: true }
            },
            {
                path: 'sentence/add',
                name: ROUTE_NAME_CHAT.SENTENCE.ADD,
                component: ChatSentenceAdd,
                meta: { requiresAuth: true }
            },
            {
                path: 'sentence/:id/edit',
                name: ROUTE_NAME_CHAT.SENTENCE.EDIT,
                component: ChatSentenceEdit,
                meta: { requiresAuth: true }
            },
            {
                path: 'sentence/:id/translate',
                name: ROUTE_NAME_CHAT.SENTENCE.TRANSLATE,
                component: ChatSentenceTranslate,
                meta: { requiresAuth: true }
            },
            {
                path: 'setting',
                name: ROUTE_NAME_CHAT.SETTING,
                component: ChatSetting,
                meta: { requiresAuth: true }
            }
        ]
    }
];
